<template>
  <div class="logo-container">
    <div class="logo">
      <img src="@/assets/logo.svg" alt="">
      <span>Säkerhets-SM 2022 Final</span>
    </div>
  </div>
  <ClockTimeline />
  <div class="button-container">
    <router-link
      v-if="!$store.state.archived"
      class="button"
      tag="button"
      :to="{ name: 'signin' }"
    >
      Registrera dig!
    </router-link>
  </div>
  <div class="content">
    <div>
      <h3>Beskrivning</h3>
      <p>
        Säkerhets-SM är en nationell Capture The Flag tävling för gymnasiet. Tävlingen fokuserar på problemlösning inom områdena programmering, kryptografi, binär exploatering, reverse engineering, webbsäkerhet och forensik. Uppgifterna varierar från nybörjarvänliga till riktigt kluriga, så även om man aldrig deltagit i en CTF förut så kan man delta. Framför allt så lär man sig mycket av att delta.
      </p>
      <p>
        CTF-tävlingar (Capture The Flag) går ut på att man i början av tävlingen får tillgång till en mängd problem och man visar att man har löst en uppgift genom att skicka in uppgiftens "flagga" till plattformen. Flaggor i den här tävlingen är textsträngar på formen <code>SSM{...}</code>.
      </p>
      <p>
        Årets tävling består av ett kval och en final. Finalen kommer att utspela sig här den 28 maj klockan 08:00-00:00.
      </p>
    </div>
    <div>
      <h3>Regler</h3>
      <ul>
        <li>Endast top 13 lag från kvalet spelar inom tävlan. Alla andra är också välkomna att spela, men då utom tävlan.</li>
        <li>Såvida inte annat uttryckligen anges är det förbjudet att diskutera problemlösningar och ledtrådar med andra medans tävlingen pågår.</li>
        <li>Det är förbjudet att vara medlem i flera lag samtidigt.</li>
        <li>Det är förbjudet att attackera CTF-platformen. Detta inkluderar brute-forcing av flaggor.</li>
        <li>Respektera problemservrarna. Skapa inte orimligt stor trafik till problemen. Inga uppgifter kräver att man skickar orimligt mycket data för att få flaggan. <div class="tooltip">?<span class="tooltiptext">Vad räknas som orimligt mycket data?<br><br>Om du ser en lösning till en uppgift som kräver några tusen requests är detta helt ok att utföra. Om din lösning kräver tio- eller hundratusentals requests är din lösning antagligen fel och du bör hitta en smidigare lösning för att inte påverka serverns prestanda medans du löser. Det är inte ok att blint spamma servern med data, till exempel genom en dum skanner som dirbuster.</span></div></li>
        <li>Det är förbjudet att störa andra personers förmåga att lösa problem.</li>
        <li>Det är förbjudet att ha mer än ett konto på CTF-platformen.</li>
        <li>Arrangörernas beslut är slutgiltiga.</li>
      </ul>
    </div>
  </div>
  <div class="centeredcontent">
  </div>
  <h3>Huvudsponsor</h3>
  <div class="mainsponsorcontainer">
    <a href="https://www.sentor.se/">
      <img class="mainsponsor" src="@/assets/sponsors/sentor.png">
    </a>
  </div>
  <h3>Sponsorer</h3>
  <div class="sponsorcontainer">
    <a href="https://www.foi.se/">
      <img class="sponsor" src="@/assets/sponsors/foi.png">
    </a>
    <a href="https://www.msab.com/">
      <img class="sponsor" src="@/assets/sponsors/msab.png">
    </a>
    <a href="https://jobb.orangecyberdefense.com/">
      <img class="sponsor" src="@/assets/sponsors/orange.png">
    </a>
    <a href="https://www.venor.se/">
      <img class="sponsor" src="@/assets/sponsors/venor.png">
    </a>
    <a href="https://www.cparta.se/">
      <img
        class="sponsor"
        src="@/assets/sponsors/cparta.jpg"
        style="border: 8px solid black"
      >
    </a>
  </div>
  <p style="text-align: center">
    Infra sponsored by <a href="https://goo.gle/ctfsponsorship">goo.gle/ctfsponsorship</a>
  </p>
</template>

<script>
import ClockTimeline from '@/components/ClockTimeline.vue'

export default {
    name: 'Home',
    components: {
        ClockTimeline,
    },
}
</script>

<style lang="scss" scoped>
.logo-container {
  .logo {
    margin-left: auto;
    margin-right: auto;
    position: relative;
    text-align: center;
    max-width: 50rem;

    span {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      font-size: 2rem;
      background-color: rgba(0,44,54, 0.4);
      padding: 0 1rem;
      word-wrap: normal;
    }
  }
}

h1, h3 {
  text-align: center;
}

p {
  padding: 0 10px 0 10px;
}

.button-container {
  margin-top: 2rem;
  text-align: center;
}

.button {
  padding: 0.6rem 1rem;
  font-size: 2rem;
  color: #ffab1c;
}

.content {
  display: grid;
  grid-template-columns: 50% 50%;
  padding-top: 3rem;
}

.centeredcontent {
  width: 50%;
  margin: 0 auto;
}

.mainsponsorcontainer {
  text-align: center;
}

.mainsponsor {
  max-width: 100%;
  max-height: 200px;
  padding-bottom: 1rem;
}

.sponsorcontainer {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
}

.sponsor {
  max-width: 90%;
  max-height: 100px;
  margin: 1rem 1rem;
}

@media only screen and (max-width: 990px) {
  .content {
    display: block;
  }

  .centeredcontent {
    width: auto;
  }
}
</style>
